import { render, staticRenderFns } from "./Dossier.vue?vue&type=template&id=5bab092a&scoped=true"
import script from "./Dossier.vue?vue&type=script&lang=js"
export * from "./Dossier.vue?vue&type=script&lang=js"
import style0 from "./Dossier.vue?vue&type=style&index=0&id=5bab092a&prod&scoped=true&lang=css"
import style1 from "./Dossier.vue?vue&type=style&index=1&id=5bab092a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bab092a",
  null
  
)

export default component.exports